import React, { useEffect, useState } from 'react';
import { View, Text, Image, StyleSheet, ScrollView, Platform } from 'react-native';
import { SearchBar } from 'react-native-elements';
import { useSelector } from 'react-redux';
import CustomSearchBar from '../components/CustomSearchBar';
// import Orientation from 'react-native-orientation-locker';


const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm) {
      return text;
    }
  
    const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
    return (
      <Text>
        {parts.map((part, i) => (
          part.toLowerCase() === searchTerm.toLowerCase()
            ? <Text key={i} style={styles.highlighted}>{part}</Text>
            : part
        ))}
      </Text>
    );
  };

const RuleDetailsScreen = ({ route, navigation }) => {
    // const { section } = route.params;
    const section = useSelector(state => state.item);
    const { searchTerm: initialSearchTerm } = route.params;
    const [searchTerm, setSearchTerm] = useState(initialSearchTerm || '');

    
    // Set the image source for section with id 2
    const paddleAndBallsImage = require('../assets/paddle_and_balls.png');
    const courtDimensionsImage = require('../assets/court_dimensions_mobile.png');
    const playingSurfaceDimensionsImage = require('../assets/playing_surface_dimensions.png');
    const netSpecificationsImage = require('../assets/net_specifications.png');
    const ipfLogo = require('../assets/ipf_logo.png');

    // Lock screen orientation to landscape when not on web
    // useEffect(() => {
    //     if (Platform.OS !== 'web') {
    //         Orientation.lockToLandscape();
    //     }

    //     return () => {
    //         if (Platform.OS !== 'web') {
    //             Orientation.lockToPortrait(); // Reset orientation when component unmounts
    //         }
    //     };
    // }, []);
    

      // Set the header title dynamically based on the section title
    React.useLayoutEffect(() => {
        navigation.setOptions({
            title: section.id +". "+ section.title, // Use the section title as the header title
            headerStyle: {
                backgroundColor: '#ffebae',
            },
            headerTitleStyle: {
                fontWeight: 'bold',
                fontSize: 14,
                color: '#6a3669',
            },
        });
    }, [navigation, section]);

    // Search and sort the rule sections by id
    const filteredSection = (section.content || [])
    .filter((contentItem) => {
        return (
            searchTerm == "" ||  // Include all items when the search term is empty
            (contentItem.text
                ? contentItem.text.toLowerCase().includes(searchTerm.toLowerCase())
                : false
            )
        );
    });


      

    const renderContentItem = (contentItem) => {
        switch (contentItem.type) {
            case 'Pg':
                return (
                    <View style={{paddingHorizontal:20, paddingTop:5, paddingBottom:10 }}>
                        <Text style={styles.contentParagraph}>
                            <Text style={styles.firstLetterForParagraph}>    {highlightSearchTerm(contentItem.text.slice(0,1), searchTerm)}</Text>
                            {/* {contentItem.text.slice(1)} */}
                            {highlightSearchTerm(contentItem.text.slice(1), searchTerm)}
                        </Text>
                    </View>
                );
            case 'Pg2':
                return (
                    <View style={{paddingHorizontal:20, paddingTop:5, paddingBottom:10 }}>
                        <Text style={[styles.contentParagraph, { paddingStart: 10 }]}>
                            {/* {contentItem.text} */}
                            {highlightSearchTerm(contentItem.text, searchTerm)}
                        </Text>
                    </View>
                );
            case 'P2':
                return (
                    <View style={{ paddingHorizontal: 20, padding: 5}}>
                        <Text style={styles.contentParagraph2}>
                            <Text style={styles.dotForParagraph}>   {highlightSearchTerm(contentItem.text.slice(0,1), searchTerm)}</Text>
                            {/* {contentItem.text.slice(1)} */}
                            {highlightSearchTerm(contentItem.text.slice(1), searchTerm)}
                        </Text>
                    </View>
                );
            case 'Ph':
                return null; // Don't display text for photos
            case 'L2':
                return (
                    <View style={{ paddingHorizontal:20, paddingTop: 2 }}>        
                        <Text style={styles.contentText}>
                            <Text style={styles.firstLevelColoredText}>{highlightSearchTerm(contentItem.text.slice(0,4), searchTerm)}</Text>
                            {/* {contentItem.text.slice(4)} */}
                            {highlightSearchTerm(contentItem.text.slice(4), searchTerm)}
                        </Text>
                    </View>
                );

            case 'L2P':
                // Split the text at ':'
                const [customStyleTextL2P, restOfTextL2P] = contentItem.text.split(':');
            
                return (
                    <View style={{ paddingHorizontal: 20, paddingTop: 2 }}>        
                        <Text style={styles.contentText}>
                            <Text style={styles.firstLevelColoredText}>{highlightSearchTerm(customStyleTextL2P, searchTerm)}:</Text>
                            {/* {restOfTextL2P} */}
                            {highlightSearchTerm(restOfTextL2P, searchTerm)}
                        </Text>
                    </View>
                );

            case 'L3':
                return (
                    <View style={{ paddingHorizontal:35, paddingTop: 2 }}>        
                        <Text style={styles.contentText}>
                            <Text style={styles.secondLevelColoredText}>{highlightSearchTerm(contentItem.text.slice(0,2), searchTerm)}</Text>
                            {/* {contentItem.text.slice(2)} */}
                            {highlightSearchTerm(contentItem.text.slice(2), searchTerm)}
                        </Text>
                    </View>
                );

            case 'L3P':
                // Split the text at ':'
                const [customStyleTextL3P, restOfTextL3P] = contentItem.text.split(':');
            
                return (
                    <View style={{ paddingHorizontal: 35, paddingTop: 2 }}>        
                        <Text style={styles.contentText}>
                            <Text style={styles.secondLevelColoredText}>{highlightSearchTerm(customStyleTextL3P, searchTerm)}:</Text>
                            {/* {restOfTextL3P} */}
                            {highlightSearchTerm(restOfTextL3P, searchTerm)}
                        </Text>
                    </View>
                );

            case 'L4':
                return (
                    <View style={{ paddingHorizontal:45, paddingTop: 2 }}>        
                        <Text style={styles.contentText}>
                            <Text style={styles.thirdLevelColoredText}>{highlightSearchTerm(contentItem.text.slice(0,2), searchTerm)}</Text>
                            {/* {contentItem.text.slice(2)} */}
                            {highlightSearchTerm(contentItem.text.slice(2), searchTerm)}
                        </Text>
                    </View>
                );

            case 'L4P':
                // Split the text at ':'
                const [customStyleTextL4P, restOfTextL4P] = contentItem.text.split(':');
            
                return (
                    <View style={{ paddingHorizontal: 45, paddingTop: 2 }}>        
                        <Text style={styles.contentText}>
                            <Text style={styles.thirdLevelColoredText}>{highlightSearchTerm(customStyleTextL4P, searchTerm)}:</Text>
                            {/* {restOfTextL4P} */}
                            {highlightSearchTerm(restOfTextL4P, searchTerm)}
                        </Text>
                    </View>
                );

            case 'L5':
                return (
                    <View style={{ paddingHorizontal:55, paddingTop: 2 }}>        
                        <Text style={styles.contentText}>
                            <Text style={styles.fifthLevelColoredText}>• </Text>
                            {/* {contentItem.text} */}
                            {highlightSearchTerm(contentItem.text, searchTerm)}
                        </Text>
                    </View>
                );
        }
    };
    


    return (
        
        <ScrollView style={styles.firstContainer}>
            <View style={styles.container}>
                    {/* <SearchBar
                        placeholder="Search the rules..."
                        placeholderTextColor={'#794a78'}
                        onChangeText={(text) => setSearchTerm(text)}
                        value={searchTerm}
                        inputStyle={styles.searchBar}
                        containerStyle={styles.searchBarContainer}  // Style for the container around the search bar
                        inputContainerStyle={styles.searchBarInputContainer}  // Style for the input container
                        searchIcon={{ size: 28, color: '#794a78' }}
                        // platform="default"  // Specify the platform (default is 'default' which works for both Android and iOS)
                        underlineColorAndroid="transparent"  // Set the underline color to transparent

                    /> */}

                <View style={Platform.OS === 'web' ? styles.searchBarContainerWeb : styles.searchBarContainer}>
                    <CustomSearchBar
                            placeholder="Search the rules..."
                            placeholderTextColor={'#794a78'}
                            onChangeText={(text) => setSearchTerm(text)}
                            value={searchTerm}
                        />
                </View>    

                {filteredSection.length > 0 && (
                <View style={Platform.select({ ios: styles.contentGroup, android: styles.contentGroup, web: styles.contentGroupWeb })}>
                    {filteredSection.map((contentGroup, groupIndex) => (
                    Array.isArray(contentGroup) ? (
                        contentGroup.map((contentItem, itemIndex) => (
                        <React.Fragment key={groupIndex + "-" + itemIndex}>
                            {renderContentItem(contentItem)}
                        </React.Fragment>
                        ))
                    ) : (
                        <React.Fragment key={groupIndex}>
                        {renderContentItem(contentGroup)}
                        </React.Fragment>
                    )
                    ))}
                </View>
                )}
                {section.id == 4 && (
                    // Render the image if imageSource is defined (section.id is 2)
                    <View>
                        <Image source={paddleAndBallsImage} style={Platform.select({ ios: styles.paddleAndBallsImageMobile, android: styles.paddleAndBallsImageMobile, web: styles.paddleAndBallsImageWeb })} /> 
                        <Text style={styles.photoTitle}>Figure 2 - Pickleball Paddle and Balls</Text>
                    
                        <Image source={courtDimensionsImage} style={Platform.select({ ios: styles.courtDimensionsImageMobile, android: styles.courtDimensionsImageMobile, web: styles.courtDimensionsImageWeb })} /> 
                        <Text style={styles.photoTitle}>Figure 3 - Court Dimensions</Text>
                    
                        <Image source={playingSurfaceDimensionsImage} style={Platform.select({ ios: styles.playingSurfaceDimensionsImageMobile, android: styles.playingSurfaceDimensionsImageMobile, web: styles.playingSurfaceDimensionsImageWeb })} /> 
                        <Text style={styles.photoTitle}>Figure 4 - Playing Surface Dimensions</Text>
                    
                        <Image source={netSpecificationsImage} style={Platform.select({ ios: styles.netSpecificationsImageMobile, android: styles.netSpecificationsImageMobile, web: styles.netSpecificationsImageWeb })} /> 
                        <Text style={styles.photoTitle}>Figure 5 - Net Specifications</Text>
                    </View>   
                )}
                <Image source={ipfLogo} style={styles.ipfLogo} /> 
            </View>
        </ScrollView>

    );
    };

const styles = StyleSheet.create({
    firstContainer: {
        backgroundColor: '#fffaeb',
    },
    container: {
        flex: 1,
        backgroundColor: '#fffaeb',
        marginTop: 20,
    },
    title: {
      fontSize: 20,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    photoTitle: {
        fontSize: 16,
        textAlign: 'center',
        color: '#6a3669',
        paddingTop: 0,
        paddingBottom: 40,
    },
    paddleAndBallsImageMobile: {
        width: '70%',
        height: undefined,
        aspectRatio: 1.9,
        alignSelf: 'center',
        marginBottom: 10,
        borderRadius: 25,
    },
    courtDimensionsImageMobile: {
        width: '120%',
        height: undefined,
        aspectRatio: 0.8,
        alignSelf: 'center',
        marginTop: 10,
        marginBottom: 10,
    },
    playingSurfaceDimensionsImageMobile: {
        width: '80%',
        height: undefined,
        aspectRatio: 1.78,
        alignSelf: 'center',
        marginTop: 10,
        marginBottom: 20,
    },
    netSpecificationsImageMobile: {
        width: '60%',
        height: undefined,
        aspectRatio: 2.2,
        alignSelf: 'center',
        marginTop: 10,
        marginBottom: 10,
    },
    paddleAndBallsImageWeb: {
        width: '35%',
        height: undefined,
        aspectRatio: 1.9,
        alignSelf: 'center',
        marginBottom: 10,
        borderRadius: 10,
    },
    courtDimensionsImageWeb: {
        width: '50%',
        height: undefined,
        aspectRatio: 0.8,
        alignSelf: 'center',
        marginTop: 10,
        marginBottom: 10,
    },
    playingSurfaceDimensionsImageWeb: {
        width: '30%',
        height: undefined,
        aspectRatio: 1.78,
        alignSelf: 'center',
        marginTop: 10,
        marginBottom: 20,
    },
    netSpecificationsImageWeb: {
        width: '30%',
        height: undefined,
        aspectRatio: 2.2,
        alignSelf: 'center',
        marginTop: 10,
        marginBottom: 10,
    },
    imageWeb: {
        width: '70%',
        height: undefined,
        aspectRatio: 1.8,
        alignSelf: 'center',
        marginBottom: 10,
    },
    ipfLogo: {
        width: '13%',
        height: undefined,
        aspectRatio: 1,
        alignSelf: 'center',
        marginBottom: 30,
        marginTop: 20,
    },
    searchBarContainer: {
        width: '45%',
        minWidth: 240,
        height: 60,
        justifyContent: 'center',
        // backgroundColor: '#794a78',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        borderWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        marginBottom: 20,
        marginTop: 10,
        alignSelf: 'center',
    },
    searchBarContainerWeb: {
        width: '70%',
        minWidth: 240,
        height: 60,
        justifyContent: 'center',
        alignSelf: 'center',
        backgroundColor: 'transparent',
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderRadius: 25,
        marginTop: 10,
        marginBottom: 20,
    },
    searchBarInputContainer: {
        backgroundColor: '#ffebae',
        borderWidth: 1,  // Remove the border on iOS
        borderBottomWidth: 1,  // Add a border to separate the search bar from the list
        borderRadius: 25,  // Round the corners of the search bar
        borderColor: '#794a78',  // Set border color to transparent
    },
    searchBar: {
        fontSize: 16,
        color: '#794a78',
    },
    contentParagraph: {
      fontSize: 16,
      color: 'black', // Default text color
    },
    contentParagraph2: {
      fontSize: 16,
      color: 'black', // Default text color
    },
    firstLetterForParagraph: {
        fontSize: 24,
        fontWeight: 'bold',
    },
    highlighted: {
        backgroundColor: '#ffebae',
    },
    dotForParagraph: {
        fontSize: 26,
        color: 'orange',
        fontWeight: 'bold',
    },
    contentText: {
      fontSize: 16,
      paddingBottom: 5,
      paddingTop: 2,
    //   marginHorizontal: 15,
      color: 'black', // Default text color
    },
    firstLevelColoredText: {
      fontSize: 16,
      color: '#6a3669',
      fontWeight: 'bold',
    },
    secondLevelColoredText: {
      fontSize: 16,
      color: 'orange',
      fontWeight: 'bold',
    },
    thirdLevelColoredText: {
      fontSize: 16,
      color: '#606060',
      fontWeight: 'bold',
    },
    fifthLevelColoredText: {
      fontSize: 18,
      color: '#606060',
      fontWeight: 'bold',
    },
    contentGroup: {
        marginHorizontal: 5,
        marginBottom: 50,
    },
    contentGroupWeb: {
        marginHorizontal: 50,
        maxWidth: 800,
        marginBottom: 50,
        alignSelf: 'center',
    }
  });
  
  export default RuleDetailsScreen;